export function yPositionIsInViewport(posY: number, viewportHeight: number, viewportOffsetPx: number, tolerance = 0) {
    return posY < viewportHeight - viewportOffsetPx + tolerance && posY > -viewportOffsetPx - tolerance;
}
